module.exports = __webpack_public_path__ + "static/media/8c1fbcb9-8839-4fe8-86ba-6bb97f7c038d_1.f7c062fdb0fc0a02d65eb08cbb6f5330.697fbd25.jpeg";